// DTM
import React from "react";
import styled from "styled-components";

import scale from "../helper/scaling";
import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 100%;
  float: left;
  padding: 31px 0;
  @media (max-width: 1100px) {
    width: calc(100% - 50px);
    padding: ${scale(1100, 767, 31, 15, "vw")} 25px;
  }
  @media (max-width: 700px) {
    margin: 23px;
    padding: 0;
    width: calc(100% - 46px);
  }
`;
const Title = styled.div`
  width: 1040px;
  height: 58px;
  font-family: Lato;
  font-size: 42px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: 0.6px;
  color: #3949ab;
  padding: 0 calc(50% - 520px);
  @media (max-width: 1100px) {
    width: 100%;
    padding: 0;

    height: ${scale(1100, 767, 58, 33, "vw")};
    font-size: ${scale(1100, 767, 42, 27, "vw")};
    line-height: ${scale(1100, 767, 42 * 1.38, 27, "vw")};
    letter-spacing: 0.4px;
  }
  @media (max-width: 800px) {
    line-height: normal;
  }
  @media (max-width: 700px) {
    width: 100%;

    height: auto;

    padding-bottom: 15px;

    font-size: 23px;
    line-height: 28px;
    letter-spacing: 0.3px;
  }
`;
const Body = styled.div`
  width: 1040px;
  font-family: Lato;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: 1.3px;
  color: rgba(0, 0, 0, 0.85);

  padding: 0 calc(50% - 520px) 0 calc(50% - 520px);

  h1,
  h2,
  h3 {
    margin: 0;
    font-family: Lato;
    font-size: 30px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.93;
    letter-spacing: 0.4px;
    color: rgba(0, 0, 0, 0.85);
  }

  @media (max-width: 1100px) {
    width: 100%;
    padding: 0;

    font-size: ${scale(1100, 767, 18, 12, "vw")};
    line-height: ${scale(1100, 767, 18 * 1.67, 12 * 1.75, "vw")};
    letter-spacing: 0.8px;

    h1,
    h2,
    h3 {
      font-size: ${scale(1100, 767, 30, 20, "vw")};

      letter-spacing: 0.3px;
    }
  }
  @media (max-width: 800px) {
    line-height: 1.75;
  }
  @media (max-width: 700px) {
    font-size: 12px;
    line-height: 1.75;
    letter-spacing: 0.8px;
    h1,
    h2,
    h3 {
      font-size: 20px;
      line-height: 24px;
      letter-spacing: 0.3px;
    }
  }
`;

class Wide extends ArticleAbstract {
  // image
  // title
  // body
  render() {
    return (
      <Wrapper>
        <Title>{this.title()}</Title>
        <Body>{this.body()}</Body>
      </Wrapper>
    );
  }
}

export default Wide;



// WEBPACK FOOTER //
// ./src/components/Wide.js